import React from 'react';
import BasicPlanIcon from '../../../../../assets/OrgDashboard/basic-plan-icon.svg';
import {
  StyledPlanCard,
  PlanHeader,
  PlanTitleSection,
  PlanTitleWrapper,
  PlanBadge,
  PlanPrice,
  PlanDates,
  DateItem,
  ProgressSection,
  ProgressItem,
  ProgressLabels,
  ProgressBarBg,
  ProgressBarFill,
  UpgradeBtnWrapper,
  UpgradeBtn
} from './style';
import { useSelector } from 'react-redux';
import { selectOrgDashboardData } from '../../../../../modules/orgDashboard';

const PlanCard: React.FC = () => {
  const dashboardData = useSelector(selectOrgDashboardData);
  const plan = dashboardData.plan;

  const usage = [
    { 
      label: 'User Allowed', 
      current: plan?.usage.users.current || 0, 
      total: plan?.usage.users.limit || 0, 
      color: '#5B9BD5' 
    },
    { 
      label: 'Workers Allowed', 
      current: plan?.usage.workers.current || 0, 
      total: plan?.usage.workers.limit || 0, 
      isUnlimited: (plan?.usage.workers.limit || 0) === -1 || (plan?.usage.workers.limit || 0) === 0 || (plan?.usage.workers.limit || 0) > 10000, 
      color: '#5E8E7E' 
    },
    { 
      label: 'Facility Count', 
      current: plan?.usage.facilities.current || 0, 
      total: plan?.usage.facilities.limit || 0, 
      isUnlimited: (plan?.usage.facilities.limit || 0) === -1 || (plan?.usage.facilities.limit || 0) === 0 || (plan?.usage.facilities.limit || 0) > 10000, 
      color: '#5E8E7E' 
    }
  ];

  return (
    <StyledPlanCard>
      <PlanHeader>
        <PlanTitleSection>
          <PlanTitleWrapper>
            <div className="icon-container">
              <img src={BasicPlanIcon} alt={plan?.plan_name || 'Plan'} />
            </div>
            <h2>{plan?.plan_name || 'No Active Plan'}</h2>
          </PlanTitleWrapper>
          <PlanPrice>
            <span>${plan?.price || 0}</span> • {plan?.validity || 0} days validity
          </PlanPrice>
        </PlanTitleSection>
        <PlanBadge>{plan?.status || 'Inactive'}</PlanBadge>
      </PlanHeader>

      <PlanDates>
        <DateItem>
          <h4>Start Date</h4>
          <p>{plan?.start_date || 'N/A'}</p>
        </DateItem>
        <DateItem>
          <h4>Expiry Date</h4>
          <p>{plan?.expiry_date || 'N/A'}</p>
        </DateItem>
        <DateItem align="right" isRed={(plan?.days_left || 0) <= 5}>
          <h4>Days Left</h4>
          <p>{plan?.days_left || 0} Days</p>
        </DateItem>
      </PlanDates>

      <ProgressSection>
        {usage.map((item, index) => {
          const isOverLimit = !item.isUnlimited && item.total > 0 && item.current > item.total;
          const isReachingLimit = !item.isUnlimited && item.total > 0 && item.current >= item.total * 0.8;
          
          let barColor = item.color;
          if (isOverLimit) {
            barColor = '#D94D4D'; // Red
          } else if (isReachingLimit) {
            barColor = '#F2994A'; // Orange (Reaching limit)
          }

          const barWidth = item.isUnlimited ? '100%' : `${Math.min((item.current / (item.total || 1)) * 100, 100)}%`;

          return (
            <ProgressItem key={index}>
              <ProgressLabels>
                <span style={{ color: isOverLimit ? '#D94D4D' : 'inherit' }}>{item.label}</span>
                <span style={{ color: isOverLimit ? '#D94D4D' : 'inherit' }}>
                  {item.isUnlimited ? 'Unlimited' : `${item.current}/${item.total}`}
                </span>
              </ProgressLabels>
              <ProgressBarBg>
                <ProgressBarFill 
                  width={barWidth}
                  color={barColor}
                />
              </ProgressBarBg>
            </ProgressItem>
          );
        })}
      </ProgressSection>

      <UpgradeBtnWrapper>
        <UpgradeBtn>Upgrade Plan</UpgradeBtn>
      </UpgradeBtnWrapper>
    </StyledPlanCard>
  );
};

export default PlanCard;
